const identityPoolId = 'us-east-1:b886ef89-6a90-4903-96fc-25af82fc629a'

exports.migrateClientIds = {
    '1oaoqf2q0cln86t4efrvnnb0mc': 'fbmolir1gpujll0ea0n33s1b1',
    '27us7b46g301msohnugokeg6s5': '3ft0g5mjgt9d35v8d6loe3aemm'
}

exports.partnerData = [
    {
        identityPoolId,
        host: 'nogartel.fleetmap.io',
        title: 'Nogartel',
        cognitoClientId: '3ft0g5mjgt9d35v8d6loe3aemm',
        oldCognitoClientIds: ['27us7b46g301msohnugokeg6s5'],
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        appId: 'e9bc85ee-71f9-4f62-b912-07ef35e48110',
        token:'M2YyM2NkMzAtNzE4OC00MTRhLWJjNDctNTVhZWZlYjVhMWRj',
        partnerId: 10,
        googleMap: true,
        forceCognito: true,
        manual: true,
        showFullDate: true,
        partnerReports: '/reports/partnerReports/',
        reports: {
            mainColor: [16, 35, 140],
            logoHeight: 14,
            logoWidth: 63,
        },
        lang: 'pt-BR',
        timezone: 'America/Sao_Paulo'
    },
    {
        identityPoolId,
        host: 'fleetmap.io',
        title: 'Fleetmap',
        cognitoClientId: '16seahimlsre6ocin0uvivtet2',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        appId: 'acd11b79-7c2b-4714-9034-5b70d47df162',
        token:'MWZkMGI2NDktYzJhMS00YjNlLWE1YjYtNjRlNGI5ZmI4NTdl',
        partnerId: 0,
        googleMap: true,
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        lang: 'en-GB'
    },
    {
        identityPoolId,
        host: 'vivacom.fleetmap.io',
        title: 'Vivacom',
        cognitoClientId: '6itrbb0q665fbs82g92h3t2ukr',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        appId: 'c1dc32a8-1e91-4426-81b9-4b883b6e7d51',
        token:'MjZhYThmODQtYmNiZC00MTg1LWI1YmUtYjg5NzAyY2YzN2I4',
        partnerId: 11,
        googleMap: true,
        reports: {
            mainColor: [246, 160, 34],
            logoHeight: 18,
            logoWidth: 21,
        }
    },
    {
        identityPoolId,
        host: 'capacitor',
        title: 'Nogartel',
        cognitoClientId: '3ft0g5mjgt9d35v8d6loe3aemm',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        appId: 'e9bc85ee-71f9-4f62-b912-07ef35e48110',
        token:'M2YyM2NkMzAtNzE4OC00MTRhLWJjNDctNTVhZWZlYjVhMWRj',
        partnerId: 10,
        googleMap: true
    },
    {
        identityPoolId,
        aws_user_pools_id: 'us-east-1_XEJ1DMDIJ',
        host: 'web.fleetrack.cl',
        title: 'Fleetrack',
        appId: '4f3f1081-5189-4715-87df-d1db684cc6a7',
        cognitoClientId: '4mnfj8aa585q67fq7v3cufuh09',
        email: 'oscar@fleetrack.cl',
        token: 'NDk1MjU2YzQtZjFiMy00NWQzLTk5Y2UtMTRhYTU5ZTAzYjNm',
        partnerId: 1,
        googleMap: true,
        showStopDate: false,
        lang: 'es-CL',
        timezone: 'America/Santiago',
        oauth_domain: 'auth.fleetmap.io',
        reports: {
            mainColor: [255, 147, 0],
            logoHeight: 14,
            logoWidth: 50,
        }
    },
    {
        identityPoolId,
        host: 'geoloc.fleetmap.io',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        cognitoClientId: 'fbmolir1gpujll0ea0n33s1b1',
        oauth_domain: 'accounts.fleetmap.io',
        appId: '368168d0-d9c0-4ecc-a936-90430f07cf3a',
        title: 'Geoloc',
        token:'ODNkZTU4M2YtNWVjZS00NzgyLWI2NWItNmU5OGYxYWViMDZj',
        partnerId: 7,
        googleMap: true,
        lang: 'es-CL',
        timezone: 'America/Santiago',
        showStopDate: true
    },
    {
        identityPoolId,
        googleMap: true,
        host: 'dev.fleetmap.io',
        oauth_domain: 'accounts.fleetmap.io',
        appId: '2cef0590-22af-4d29-85f0-1edaa5279b9c',
        cognitoClientId: '2gcl7rh96fvf73vpo871sb6nb9',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        token: 'ZWM3YTI1YWEtMzQxNC00MDY2LTgwYTctYzA1NjgxYmE5YjE5',
        showStopDate: true,
        partnerId: 4,
        region: 'MA',
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        }
    },
    {
        identityPoolId,
        appId: 'd48134b7-ab16-4065-9ff8-54a3465f258a',
        token: 'MjEwNGJhOTgtZTdjNy00MTdmLWJkOTItNjUyN2Q2N2YxM2E5',
        host: 'fleetmap.io',
        googleMap: true,
        partnerId: 0,
        title: 'Fleetmap',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: '16seahimlsre6ocin0uvivtet2',
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        }
    },
    {
        emailRuleType: 'string',
        identityPoolId,
        appId: '9d77aa60-71f5-4fc9-b288-8c81fb0db985',
        token: 'NDE0OGRhM2UtN2Y4YS00YjNhLTlmNDgtYWE1MDE2OGVlZGYy',
        host: 'aft-systems.org',
        partnerId: 6,
        googleMap: true,
        title: 'AFTS',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: '1t327n9mfchj7c8punqusp0j01',
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        prefs: {
            dashboard: false
        }
    },
    {
        identityPoolId,
        appId: '58ccb0c0-c958-46c4-92a5-cefcd8dd9390',
        token: 'ODdkODU2MzktNzgwOS00YWVhLWJjZjctNTgxNzQwZjM0MzQw',
        host: 'localizalia.net',
        title: 'Localizalia',
        googleMap: true,
        minDaysForDisconnected: 15,
        partnerId: 14,
        showStopDate: true,
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: '14bad1k5truh9sffa2d5m6h0iu',
        oldCognitoClientIds: ['6udglokm8muv3j06tnledmo0ki'],
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        prefs: {
            maxSpeedType: 'road',
            tacho: true
        },
        lang: 'es-CL',
        timezone: 'Europe/Madrid'
    },
    {
        identityPoolId,
        appId: '58ccb0c0-c958-46c4-92a5-cefcd8dd9390',
        token: 'ODdkODU2MzktNzgwOS00YWVhLWJjZjctNTgxNzQwZjM0MzQw',
        host: 'web.localizalia.net',
        title: 'Localizalia',
        googleMap: true,
        minDaysForDisconnected: 15,
        partnerId: 14,
        showStopDate: true,
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: '14bad1k5truh9sffa2d5m6h0iu',
        oldCognitoClientIds: ['6udglokm8muv3j06tnledmo0ki'],
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        prefs: {
            maxSpeedType: 'road',
            tacho: true
        },
        lang: 'es-CL',
        timezone: 'Europe/Madrid'
    },
    {
        identityPoolId,
        appId: '3780f912-d385-4876-8f47-73be1f8cf260',
        token: 'YjMwN2NkMjAtOGMyMi00NDA1LThlMTktNTJhMjA4N2Y3Yjdi',
        host: 'retatrack.com',
        title: 'Retatrack',
        partnerId: 16,
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: '3ut58kljsnqhu394rac76lp6t4',
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        lang: 'pt-BR',
        timezone: 'America/Sao_Paulo'
    },
    {
        identityPoolId,
        appId: 'efc97e90-f7ff-47e0-be67-97f5b60a0ee5',
        token: 'Zjg2ZmFkZjMtZGM3Ny00YTNmLTk5ZGQtZjk1ZTU0MjVjNWE5',
        host: 'localizegps.com',
        title: 'Localize',
        partnerId: 17,
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        cognitoClientId: 'u507tjqm7ulvbrue0pjn7br21',
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        lang: 'pt-BR',
        timezone: 'America/Sao_Paulo'
    },
    {
        identityPoolId: identityPoolId,
        host: 'localhost',
        appId: '5be94b69-6e16-42ff-bca4-96b0454296ba',
        token: 'M2Q1MjU4MjMtNzBjYy00Y2Q1LWE5MWUtMGU1ZmYzY2I0NGU0',
        cognitoClientId: '16seahimlsre6ocin0uvivtet2',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 0,
        googleMap: true,
        forceCognito: true,
        showStopDate: true,
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        }
    },
    {
        title: 'Samtech',
        aws_cognito_region: 'sa-east-1',
        identityPoolId: 'sa-east-1:6dc5bd95-fda8-441f-bad3-bcbfb2ec3bdf',
        host: 'vz.samtech.cl',
        appId: '3d655aa2-db87-474f-abcf-d8e0d588378b',
        token: 'MTJiODk4OTMtNGUyNS00NTEyLWE2ZTAtMjc1YjBhMzcyMTRj',
        cognitoClientId: '280g63c53bs52rhn9u3mdkp487',
        aws_user_pools_id: 'sa-east-1_b7SDvkW1U',
        oauth_domain: 'fleetmap.auth.sa-east-1.amazoncognito.com',
        partnerId: 23,
        googleMap: true,
        manual: true,
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
        },
        legacyMap: '/legacy'
    },
    {
        title: 'Fleetmap',
        aws_cognito_region: 'sa-east-1',
        identityPoolId: 'sa-east-1:6dc5bd95-fda8-441f-bad3-bcbfb2ec3bdf',
        host: 'api2.pinme.io',
        appId: '3f0efe9b-741c-4a91-b722-8c3a844fc28b',
        token: 'ZDA4OGE0ZjEtY2JiMy00MThmLWEzMmUtYWZhNzE4ZTdhODk2',
        cognitoClientId: '280g63c53bs52rhn9u3mdkp487',
        aws_user_pools_id: 'sa-east-1_b7SDvkW1U',
        oauth_domain: 'fleetmap.auth.sa-east-1.amazoncognito.com',
        partnerId: 0,
        googleMap: true,
    },
    {
        identityPoolId: identityPoolId,
        host: 'moviflotte.com',
        title: 'Moviflotte',
        appId: '58c2443e-c3fe-4546-affe-7752337c8940',
        token: 'NGQ1MTliNDAtMDIyMi00NDRmLWFjMjYtYmQwNzI3MGIyYjdj',
        cognitoClientId: '66bdcajkmu4i8o64k978iqsl83',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 5,
        googleMap: true,
        forceCognito: true,
        showStopDate: false,
        zoomToDevice: false,
        region: 'MA',
        manual: true,
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
            kmsReportDaysInColumns: true
        },
        prefs: {
            dashboard: true
        },
        scheduler: true,
        lang: 'fr-FR',
        timezone: 'Africa/Casablanca',
        externalReports: {
            url: 'https://moviflotte.com/pinmeapi/redirect/%3F?redirectUrl=https%3A%2F%2Fornate-factor-96410.appspot.com',
            title: 'Rapports Externes'
        },
        partnerReports: '/reports/moviflotte/',
        legacyMap: '/legacy'
    },
    {
        identityPoolId: identityPoolId,
        host: 'web.moviflotte.com',
        title: 'Moviflotte',
        appId: '58c2443e-c3fe-4546-affe-7752337c8940',
        token: 'NGQ1MTliNDAtMDIyMi00NDRmLWFjMjYtYmQwNzI3MGIyYjdj',
        cognitoClientId: '66bdcajkmu4i8o64k978iqsl83',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 5,
        googleMap: true,
        forceCognito: true,
        showStopDate: false,
        zoomToDevice: false,
        region: 'MA',
        manual: true,
        reports: {
            mainColor: [33, 159, 215],
            logoHeight: 20,
            logoWidth: 40,
            kmsReportDaysInColumns: true
        },
        prefs: {
            dashboard: false
        },
        scheduler: true,
        lang: 'fr-FR',
        timezone: 'Africa/Casablanca',
        externalReports: {
            url: '/pinmeapi/redirect/%3F?redirectUrl=https%3A%2F%2Fornate-factor-96410.appspot.com',
            title: 'Rapports Externes'
        },
        partnerReports: '/reports/moviflotte/',
        legacyMap: '/legacy'
    },
    {
        identityPoolId: identityPoolId,
        host: 'leaseplan.fleetmap.io',
        title: 'Leaseplan',
        appId: '440ca468-d396-496c-b90f-575c1f34204b',
        token: 'NmI2ZDUwMzktNjZmMS00ZWE2LTk5MGYtNWZmYTY5YTAzNzc3',
        cognitoClientId: '311kru4ak91h32fphssge3ihmr',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 18,
        showStopDate: true,
        reports: {
            mainColor: [237, 139, 0],
            logoHeight: 20,
            logoWidth: 40,
        }
    },
    {
        identityPoolId: identityPoolId,
        host: 'safetracking.net',
        title: 'Safe tracking',
        appId: '33be1236-21b5-4ef4-b111-bd05db269156',
        token: 'NmVmNjA5YmUtYjZhOC00YTVlLTg2NDAtZDA2ZmQzYmUzZWI4',
        cognitoClientId: '5ofd46m2dvv7nh9qene1efjirc',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 19
    },
    {
        aws_cognito_region: 'sa-east-1',
        identityPoolId: 'sa-east-1:6dc5bd95-fda8-441f-bad3-bcbfb2ec3bdf',
        host: 'afconsultingsystems.com',
        title: 'AF Consulting',
        appId: '3f7d106e-ae34-4f17-8e03-a556ff2ded1f',
        token: 'MDkzNWViZWUtN2Y4Mi00YWZjLTk1ZDktYjg3NDVhOWFjODBk',
        cognitoClientId: 'kdio6kfhof25sgcuutstgtla5',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 12,
        lang: 'fr-FR',
        timezone: 'Africa/Senegal',
        manual: true,
        prefs: {
            scheduler: true,
        }
    },
    {
        identityPoolId: identityPoolId,
        host: 'bizfleet.net',
        title: 'Bizfleet',
        appId: 'bb8e2ed4-1be5-4c6a-9bd9-23c101427d24',
        token: 'ZGQyMzEwMDAtMDNjYy00NDg0LTg2NDAtMmVkNTk4Y2RlNDM0',
        cognitoClientId: '4522d3th91nl7cqv36v0vbon4g',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 20
    }, {
        identityPoolId: identityPoolId,
        host: 'plataforma.ubisat.cl',
        title: 'Ubisat',
        appId: 'fa9ae6e9-afeb-4ad8-84ac-c3bde2963ffe',
        token: 'MDU4YTRhMGEtNWVkYi00MjJiLWEyYTEtM2Y2OTdhZjJlNjRm',
        cognitoClientId: '3td8ldqbjupl0omlq00msv6bf',
        aws_user_pools_id: 'us-east-1_SWTiH7d38',
        oauth_domain: 'accounts.fleetmap.io',
        partnerId: 22,
        googleMap: true,
        lang: 'es-CL',
        timezone: 'America/Santiago',
        reports: {
            mainColor: [221, 0, 15],
            logoHeight: 14,
            logoWidth: 50,
        }
    }, {
        host: 'plataforma.puntosat.cl',
        title: 'Puntosat',
        partnerId: 24,
        lang: 'es-CL',
        timezone: 'America/Santiago',
        manual: true
    }
]
